import React from "react";
import { Form, Input } from "antd";

interface Props {
  activeQuestion?: any;
}

const ExtraInformationTextArea: React.FC<Props> = (props) => {
  return (
    <div className="answer-input-wrapper">
      <Form.Item name={props?.activeQuestion?.data?.question}>
        <Input.TextArea rows={12} placeholder="Tell us More (Optional)" />
      </Form.Item>
    </div>
  );
};

export default ExtraInformationTextArea;
